import { useState } from "react";

import { deleteIdeasMany as deleteContradictionsSolvings } from "../../../api/contradictionsSolvings";
import { deleteIdeasMany as deleteDetailsMatrix } from "../../../api/detailsMatrix";
import { deleteIdeasMany as deleteEurekas } from "../../../api/eureka";
import { deleteIdeasMany as deleteMultiplications } from "../../../api/multiplication";
import { deleteIdeasMany as deleteReplacements } from "../../../api/replacement";
import { deleteIdeasMany as deleteSubtractions } from "../../../api/subtractions";
import { archiveIdeas } from "../../../api/trash";

const getParams = (ideas) => ideas.map((idea) => idea.id);

const getParamsForDelete = (ideas) =>
  ideas.map((id) => ({
    issues: [],
    ideaId: id,
  }));

export const useDeleteIdeas = (setModalOpen, initialModalOpen, getProjectInfoForReports, setActiveTab, projectId) => {
  const [pendingDeleteIdeas, setPendingDeleteIdeas] = useState(false);
  const [lengthArchivedIdeas, setlengthArchivedIdeas] = useState();

  const archivedIdeas = async (ideasToDelete) => {
    //EUREKA
    const ideasEureka = ideasToDelete.filter((idea) => idea.type === "eureka");
    const eurekasIds = getParams(ideasEureka);

    //CONTRADICTIONS SOLVING
    const ideasContradictionsSolving = ideasToDelete.filter((idea) => idea.type === "contradictionsSolving");
    const contradictionsSolvingsIds = getParams(ideasContradictionsSolving);

    //MULTIPLICATION
    const ideasMultiplication = ideasToDelete.filter((idea) => idea.type === "multiplication");
    const multiplicationsIds = getParams(ideasMultiplication);

    //DETAILS MATRIX
    const ideasDetailsMatrix = ideasToDelete.filter((idea) => idea.type === "dependency");
    const detailsMatrixIds = getParams(ideasDetailsMatrix);

    //SUBTRACTIONS
    const ideasSubtractions = ideasToDelete.filter((idea) => idea.type === "subtraction");
    const subtractionsIds = getParams(ideasSubtractions);

    //REPLACEMENT
    const ideasReplacement = ideasToDelete.filter((idea) => idea.type === "replacement");
    const replacmentsIds = getParams(ideasReplacement);

    await archiveIdeas(
      {
        ideas: {
          contradictionsSolvingsIds,
          detailsMatrixIds,
          eurekasIds,
          replacmentsIds,
          multiplicationsIds,
          subtractionsIds,
        },
        productId: ideasToDelete[0].productId,
      },
      ({ trashFull, lengthArchivedIdeas }) => {
        if (trashFull) {
          setModalOpen({ ...initialModalOpen, delete: true });
          setlengthArchivedIdeas(lengthArchivedIdeas);
        } else {
          getProjectInfoForReports(projectId);
          setActiveTab(0);
        }
        setPendingDeleteIdeas(false);
      },
    );
  };

  const deleteIdeas = async (ideasToDelete) => {
    setPendingDeleteIdeas(true);
    //EUREKA
    const ideasEureka = ideasToDelete.filter((idea) => idea.type === "eureka");
    const eurekasIds = getParams(ideasEureka);

    if (eurekasIds.length) {
      const params = getParamsForDelete(eurekasIds);

      await deleteEurekas(params);
    }

    //CONTRADICTIONS SOLVING
    const ideasContradictionsSolving = ideasToDelete.filter((idea) => idea.type === "contradictionsSolving");
    const contradictionsSolvingsIds = getParams(ideasContradictionsSolving);

    if (contradictionsSolvingsIds.length) {
      const params = getParamsForDelete(contradictionsSolvingsIds);

      await deleteContradictionsSolvings(params);
    }

    //MULTIPLICATION
    const ideasMultiplication = ideasToDelete.filter((idea) => idea.type === "multiplication");
    const multiplicationsIds = getParams(ideasMultiplication);

    if (multiplicationsIds.length) {
      const params = getParamsForDelete(multiplicationsIds);

      await deleteMultiplications(params);
    }

    //DETAILS MATRIX
    const ideasDetailsMatrix = ideasToDelete.filter((idea) => idea.type === "dependency");
    const detailsMatrixIds = getParams(ideasDetailsMatrix);

    if (detailsMatrixIds.length) {
      const params = getParamsForDelete(detailsMatrixIds);

      await deleteDetailsMatrix(params);
    }

    //SUBTRACTIONS
    const ideasSubtractions = ideasToDelete.filter((idea) => idea.type === "subtraction");
    const subtractionsIds = getParams(ideasSubtractions);

    if (subtractionsIds.length) {
      const params = getParamsForDelete(subtractionsIds);

      await deleteSubtractions(params);
    }

    //REPLACEMENT
    const ideasReplacement = ideasToDelete.filter((idea) => idea.type === "replacement");
    const replacmentsIds = getParams(ideasReplacement);

    if (replacmentsIds.length) {
      const params = getParamsForDelete(replacmentsIds);

      await deleteReplacements(params);
    }

    setTimeout(() => {
      getProjectInfoForReports(projectId);
      setActiveTab(0);
      setPendingDeleteIdeas(false);
      setlengthArchivedIdeas();
    }, 0);
  };

  return { archivedIdeas, pendingDeleteIdeas, deleteIdeas, lengthArchivedIdeas };
};
